<!--  -->
<template>
  <div class="newsnav">
    <div class="newsnav-box">
      <ul class="fenlei">
        <li
          :class="{ active: item.id == onSelect }"
          v-for="(item, index) in fenlei"
          :key="index"
          @click="chengeFenlei(item.id)"
        >
          <span>{{ item.title }}</span>
        </li>
      </ul>
      <ul class="nianfen">
        <li
          :class="{ nianfenactive: index === nianSelect }"
          v-for="(item, index) in nianfen"
          :key="index"
          @click="chengeNianfen(index, item.year)"
        >
          <span>{{ item.year }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      cid: 0,
      nian: "",
      fenlei: [
        /* 
        {
          title: "分类1",
          id: "1",
        },
        {
          title: "分类2",
          id: "2",
        },
        {
          title: "分类3",
          id: "3",
        },
       */
      ],
      nianfen: [
        /* 
        {
          year: "2021",
          id: "2021",
        },
        {
          year: "2021",
          id: "2021",
        }, */
      ],
      onSelect: "",
      nianSelect: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      this.onSelect = parseInt(this.$route.query.cid);
      if (this.$route.query.cid == "") {
        this.get_nian(33); //得到年份,默认第1个分类是33
      }
    },
  },
  //方法集合
  methods: {
    flushCom: function () {
      this.$router.go(0);
    },
    //1.得到新闻分类
    get_class() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 5,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.fenlei.push({
                title: k.title,
                id: k.id,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.得到年份
    get_nian(cid) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_years",
          cid: cid,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.nianfen = [];
            $.each(obj.data, function (i, k) {
              that.nianfen.push({
                year: k,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    // 选择分类
    chengeFenlei(id) {
      this.onSelect = id;

      //更新年份@2021.08.09
      this.get_nian(id);

      this.$emit("child-id", id);
      this.$emit("child-id-year", this.nianfen[0].year);
      this.nianSelect = 0;
    },
    chengeNianfen(id, year) {
      this.nianSelect = id;
      this.$emit("child-year", year);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_class();
    this.onSelect = parseInt(this.$route.query.cid);
    if (this.$route.query.cid == "") {
      this.get_nian(33); //得到年份,默认第1个分类是33
    }
    this.get_nian(this.onSelect);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.newsnav {
  width: 100%;
  height: 86px;
  background: #47aeea;
  .newsnav-box {
    width: $main-width;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .fenlei {
    display: flex;
    position: absolute;
    right: 0;
    top: -50px;
    li {
      padding: 6px 10px;
      cursor: pointer;
      transition: 0.3s;
      span {
        font-size: 1rem;
        color: #666;
      }
    }
    .active {
      background: #f8ad17;
      span {
        color: #fff;
      }
    }
    li:hover {
      background: #f8ad17;
    }
    li:hover span {
      color: #fff;
    }
  }
  .nianfen {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      margin: 0 10px;
      height: 100%;
      cursor: pointer;
      transition: 0.3s;
      span {
        color: #fff;
        font-size: 1.2rem;
      }
    }
    .nianfenactive {
      background: #fada00;
    }
    li:hover {
      background: #fada00;
    }
  }
}
@media screen and (max-width: $main-width) {
  .newsnav {
    margin-top: 40px;
    .newsnav-box {
      width: 100%;
      .nianfen {
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news/NewsNav.vue